var _rect, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 12,
    fill: "#160A2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5787 14.1494C21.5669 10.5289 19.4874 7.11779 17.0986 12.1215C16.7718 12.7648 16.5336 14.0149 16 14.0149V14.0086C15.4664 14.0086 15.2283 12.7584 14.9015 12.1152C12.5126 7.11144 10.4331 10.5225 8.42128 14.143C8.26989 14.4161 8.12445 14.6767 8 14.9031C12.6103 11.9011 12.2222 20.9704 16 21.0425V21.0489C19.7779 20.9768 19.3897 11.9074 24 14.9094C23.8756 14.683 23.7302 14.4224 23.5787 14.1494Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87943 15.0854C10.0568 13.6951 11.0921 15.0274 12 16.7798C11.2487 18.1686 10.7517 19.0162 10.5088 19.3224C10.051 19.9001 9.55142 20.3375 8.93707 20.5899C7.64551 21.2061 6.03993 21.235 4.80005 20.4731L7.87943 15.0854Z",
    fill: "url(#paint0_linear_1522_79)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6001 21.0489C24.7046 21.0489 25.6001 20.1335 25.6001 19.0044C25.6001 17.8753 24.7046 16.96 23.6001 16.96C22.4956 16.96 21.6001 17.8753 21.6001 19.0044C21.6001 20.1335 22.4956 21.0489 23.6001 21.0489Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1522_79",
    x1: 7.42998,
    y1: 13.9118,
    x2: 7.42998,
    y2: 27.9875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMLogo);
export default __webpack_public_path__ + "static/media/mLogo.96e4d0e5eba24f1a2c63e4fb0acc658c.svg";
export { ForwardRef as ReactComponent };